module.exports = __webpack_public_path__ + "img/auth-back.1b6189d6.jpg";